import React, { useMemo } from 'react';
import Image from 'next/legacy/image';
import spaScheduleIcon from '@assets/images/spa-schedule-icon.png';
import Product from '@customTypes/product';
import { spaBannerProducts } from '@constants/productType';

export default function SpaBanner({ product }: { product: Product }) {
  const isSpaProduct = useMemo(
    () => spaBannerProducts.includes(product.product_type.toLowerCase()),
    [product.product_type],
  );
  return isSpaProduct ? (
    <div
      className={`py-6 flex items-center gap-3 d:pl-2 ${product.description ? 'd:pt-0' : 'd:pt-3'}`}
    >
      <div className="flex items-center w-10 h-10">
        <Image
          src={spaScheduleIcon}
          alt="spa schedule icon"
          width={40}
          height={46}
          layout="fixed"
        />
      </div>
      <span className="text-sm font-rp-pn-regular text-rp-primary-black mt-0">
        Post-purchase, you&apos;ll be provided details for scheduling your treatment
      </span>
    </div>
  ) : null;
}
